import Suspense from "components/shared/Suspense";
import { lazy, useState } from "react";
import InctiveSortBooksButton from "./InactiveSortBooksButton";
import { LetterbookSettingType } from "features/Letterbooks/types";

const ActiveSortBooksButton = lazy(() => import("./ActiveSortBooksButton"));

interface LetterbookOptions {
  settings: LetterbookSettingType;
}

export default function SortDropdown({
  settings,
}: LetterbookOptions) {
  const [clicked, setClicked] = useState(false);

  return (
    <>
      {clicked ? (
        <Suspense
          fallback={<InctiveSortBooksButton settings={settings} loading />}
        >
          <ActiveSortBooksButton settings={settings} />
        </Suspense>
      ) : (
        <InctiveSortBooksButton onClick={setClicked} settings={settings} />
      )}
    </>
  );
}
